import {faCircleExclamation} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Input from 'components/Input/Input';
import './FormControl.scss';
import Text from 'components/Text/Text';

interface IProps {
  name?: string;
  label?: string;
  value: string;
  onChange?: (e: string) => void;
  placeholder?: string;
  type?: string;
  id?: string;
  disabled?: boolean;
  labelClassname?: string;
  hasButton?: boolean;
  buttonTitle?: string;
  onClick?: () => void;
  error?: string;
}

const FormControl = ({
  error,
  name = '',
  label = '',
  value = '',
  onChange = () => {},
  placeholder = '',
  type = 'text',
  id = '',
  disabled,
  labelClassname = '',
  hasButton,
  buttonTitle,
  onClick,
}: IProps) => {
  return (
    <div className={`form-control ${value ? 'form-control--input' : ''}`}>
      {label !== '' && (
        <label className={`form-control__label ${labelClassname}`} htmlFor={name}>
          {label}
        </label>
      )}
      <div className={`form-control__wrapper ${error ? 'form-control__wrapper--error' : ''}`}>
        <Input
          type={type}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          id={id}
          disabled={disabled}
        />
        {error && <FontAwesomeIcon icon={faCircleExclamation} />}
      </div>
      {hasButton && (
        <button type="button" className="form-control__button" onClick={onClick}>
          {buttonTitle}
        </button>
      )}

      <Text tag="p" className="form-control__error">
        {error && error}
      </Text>
    </div>
  );
};

export default FormControl;
